import { render, staticRenderFns } from "./TaHardwaresGroup.vue?vue&type=template&id=3740172b"
import script from "./TaHardwaresGroup.vue?vue&type=script&lang=js"
export * from "./TaHardwaresGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports